import { useState } from "react";
import { Link } from "react-router-dom";
import ArticleCard from "@/components/base/ArticleCard";
import SectionTitle from "@/components/base/SectionTitle";
import { categories } from "@/mocks/categories";
import { articles } from "@/mocks/articles";
import { allCategory, getArticlesByCategory, sortArticles } from "@/utils/content";

const tabs = [{ slug: "all", name: "全部" }, ...categories.map((item) => ({ slug: item.slug, name: item.short }))];

export default function LatestFeed() {
  const [active, setActive] = useState("all");
  const [visible, setVisible] = useState(6);

  const source = sortArticles(
    active === "all" ? articles : getArticlesByCategory(active),
    "latest",
  );

  const shown = source.slice(0, visible);

  return (
    <section id="latest" className="w-full scroll-mt-20 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-8">
        <SectionTitle
          eyebrow="最新爆料内容流"
          title="按时间更新的内容流"
          description={allCategory.desc}
          actionLabel="进入完整列表"
          actionTo="/category/all"
        />

        <div className="mt-6 flex w-full justify-start">
          <div className="flex flex-wrap items-center gap-1 rounded-full border border-background-200 bg-background-100 px-1 py-1">
            {tabs.map((tab) => (
              <button
                key={tab.slug}
                type="button"
                onClick={() => {
                  setActive(tab.slug);
                  setVisible(6);
                }}
                className={`whitespace-nowrap rounded-full px-3.5 py-1.5 text-sm font-medium transition-colors ${
                  active === tab.slug
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-700 hover:bg-background-200"
                }`}
              >
                {tab.name}
              </button>
            ))}
          </div>
        </div>

        {shown.length > 0 ? (
          <>
            <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
              {shown.map((item) => (
                <ArticleCard key={item.id} article={item} />
              ))}
            </div>

            {visible < source.length && (
              <div className="mt-8 flex justify-center">
                <button
                  type="button"
                  onClick={() => setVisible((prev) => prev + 3)}
                  className="whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-2.5 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
                >
                  加载更多内容
                  <i className="ri-arrow-down-line ml-1" />
                </button>
              </div>
            )}
          </>
        ) : (
          <p className="mt-10 rounded-lg border border-background-200 bg-background-50 p-8 text-center text-sm text-foreground-600">
            这个分类暂时还没有内容，换个分类看看？
          </p>
        )}

        <p className="mt-8 text-center text-xs text-foreground-500">
          想要更细的筛选？进入
          <Link to="/category/all" className="mx-1 font-semibold text-primary-600 hover:underline">
            全部爆料
          </Link>
          可以按关键词继续查找。
        </p>
      </div>
    </section>
  );
}